module.exports = __webpack_public_path__ + "static/img/product_meetingRollCall.27faf0c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/product/product_meetingRollCall.jpg
// module id = lTNn
// module chunks = 0